import ReactPlayer from "react-player";
import { mdiAlertCircleOutline } from "@mdi/js";
import Icon from "@mdi/react";
import { useToggle } from "usehooks-ts";

import Radio from "components/Radio";
import TipModal from "components/TipModal";
import { POST_TRUCK_HELP } from "constants/link";
import useDeviceType from "hooks/useDeviceType";
import styles from "./style.module.scss";

interface IProps {
  setPostType: (value: string) => void;
  postType: string;
}

export default function TruckPostSubHeader({ postType, setPostType }: Readonly<IProps>) {
  const { isDesktop } = useDeviceType();
  const [isTipModalOpen, toggleTipModal] = useToggle();

  return (
    <div className={styles.trucksPostHeaderActions}>
      <div className={styles.headerSubTab}>
        <Radio
          label="By City"
          onChange={() => setPostType("city")}
          name="postHeader"
          className="text-placeholder"
          checked={postType === "city"}
        />
        <Radio
          label="By State"
          onChange={() => setPostType("state")}
          name="postHeader"
          className="text-placeholder"
          checked={postType === "state"}
        />
      </div>

      {isDesktop ? (
        <button
          type="button"
          onClick={toggleTipModal}
          className="flex justify-end gap-2 ml-3 underline">
          <Icon path={mdiAlertCircleOutline} />
          <span>Pro Tip</span>
        </button>
      ) : (
        <button className={styles.headerTipButton} onClick={toggleTipModal}>
          ProTip
        </button>
      )}

      <TipModal
        isModalOpen={isTipModalOpen}
        toggleModal={toggleTipModal}
        title="Post Truck"
        content={
          <div className="h-full px-2 overflow-y-auto">
            <div className="text-xs desktop:text-sm">
              <p className="py-2">
                You can use Post Truck to match your current and future upcoming empty trucks based
                on lanes you prefer to haul on or that your company regularly services. The more
                posted trucks (or lanes?) using Post Truck means more chances that a shipper or
                broker will match their posted loads to you and enquire about doing business with
                you directly.
              </p>
              <p className="py-2">
                Also be sure to always set the end date as far out in the future as you think you
                will be covering or be able to cover a lane or region for hauling so you don’t miss
                any matches.
              </p>
              <p className="py-2">
                To manage alerts for new load matches for posted trucks navigate to Notifications
                section of Settings. You may want to disable Email Notifications for State to State
                Truck Posts that cover much larger areas or time windows so your inbox doesn’t
                overflow.
              </p>
            </div>

            <ReactPlayer url={POST_TRUCK_HELP} playing={false} controls={true} width="100%" />
          </div>
        }
      />
    </div>
  );
}
